var _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2Tone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0507812,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#004025"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_143_1882",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 37
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.550781,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#004025"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.550781,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "white",
    strokeMiterlimit: 6.69898
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_143_1882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 -4.94922L56.0477 39.3008H4.95225L30.5 -4.94922Z",
    fill: "#979797"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2Tone);
export default __webpack_public_path__ + "static/media/icon-2tone.ec745ca1ac9d675d6831f6aec95e9131.svg";
export { ForwardRef as ReactComponent };